<template>
  <div class="main">
    <h3 class="textPath">
      {{ category.name }}/{{ subcategory.name }}
    </h3>
    <div class="">
      <div class="box">
        <div v-for="property in propertiesShown" :key="property.id">
          <div class="pointer" @click="goToProperty(property.id)">
            <Card style="width: 19rem; margin-top: 1em"
              v-bind:style="property.isVisible ? 'opacity: 1;' : 'opacity: 0.5;'">
              <template slot="header">
                <div class="containerImages border-width: 0">
                  <img
                    alt="user header"
                    class="imageProperties"
                    :src="property.images.length ? property.images[0].image : ''"
                    height="150"
                  />
                  <div class="center" v-show="property.sold">
                    <img :src="`../img/${category.name}.png`" />
                  </div>
                </div>
              </template>
              <template slot="title">
                {{ formatCurrency(property.price) }}
              </template>
              <template slot="content">
                {{ property.brief_description }}
              </template>
              <template slot="footer"> Ref: {{ property.id }} </template>
            </Card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Card from 'primevue/card';
import { mapState } from 'vuex';

export default {
  components: {
    Card,
  },
  props: {
    subcategory_id: String,
  },
  data() {
    return {
      propertiesShown: [],
      page: 0,
      category: '',
      subcategory: '',
    };
  },
  computed: {
    ...mapState('properties', ['properties', 'showInvisibleProperties']),
    ...mapState('categories', ['categories']),
  },
  watch: {
    subcategory_id: {
      immediate: true,
      deep: true,
      handler(newValue) {
        [this.category] = this.categories.filter((category) => {
          return (
            category.subcategories.filter((subcategory) => {
              return subcategory.id === parseInt(newValue, 10);
            }).length > 0
          );
        });
        [this.subcategory] = this.category.subcategories.filter((subcategory) => {
          return subcategory.id === parseInt(newValue, 10);
        });
        this.propertiesShown = [];
        this.page = 0;
        this.retrieveProperties(newValue);
        this.scroll();
      },
    },
    showInvisibleProperties: {
      immediate: true,
      deep: true,
      handler() {
        this.propertiesShown = [];
        this.page = 0;
        this.retrieveProperties(this.subcategory_id);
      },
    },
  },
  methods: {
    formatCurrency(value) {
      if (value) {
        return value.toLocaleString('pt-br', {
          style: 'currency',
          currency: 'BRL',
        });
      }
    },
    goToProperty(propertyId) {
      this.$router.push(`/property/${propertyId}`);
    },
    scroll() {
      window.onscroll = () => {
        const bottomOfWindow = document.documentElement.scrollTop
          + window.innerHeight + 400 > document.documentElement.offsetHeight;

        if (bottomOfWindow) {
          this.retrieveProperties(this.subcategory_id);
        }
      };
    },
    retrieveProperties(subcategoryId) {
      this.propertiesShown.push(...this.properties.filter((property) => {
        let returnValue = false;
        if (this.showInvisibleProperties) {
          returnValue = true;
        } else if (property.isVisible) {
          returnValue = true;
        }
        return property.subcategory_id === parseInt(subcategoryId, 10) && returnValue;
      }).slice(this.page * 10, (this.page + 1) * 10));
      this.page += 1;
    },
  },
};
</script>

<style>
.main {
  margin-bottom: 16px;
}
.box {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-around;
}
.pointer {
  cursor: pointer;
}
.imageProperties {
  border-radius: 3px;
  width: 100%;
  height: auto;
  margin: 2px;
}
.containerImages {
  position: relative;
  margin-top: 5px;
  margin-right: 4px;
}

.center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.textPath {
  text-align: left;
  margin-left: 16px;
  margin-top: 16px;
}
</style>
